import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {EnrichmentResponse} from 'nutshell-graphql-types';
import type {
    AccountEnrichmentRespond as AccountEnrichmentRespondMutation,
    AccountEnrichmentRespondVariables as AccountEnrichmentRespondMutationVariables,
} from 'nutshell-graphql-types';

import ACCOUNT_ENRICHMENT_RESPOND from './../mutations/account-enrichment-respond.graphql';

export function useAccountEnrichmentRespond(accountId: string): {
    accountEnrichmentRespond: (arg1: EnrichmentResponse) => Promise<any>;
    error: string | null | undefined;
    loading: boolean;
} {
    const [accountEnrichmentRespond, {error, loading}] = useMutation<
        AccountEnrichmentRespondMutation,
        AccountEnrichmentRespondMutationVariables
    >(ACCOUNT_ENRICHMENT_RESPOND);

    return {
        accountEnrichmentRespond: (response: EnrichmentResponse) =>
            accountEnrichmentRespond({
                variables: {
                    input: {
                        accountId,
                        response,
                    },
                },
            }),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        loading,
    };
}
